// extracted by mini-css-extract-plugin
export var callCard = "_r8-0";
export var callMessageButton = "_r8-1";
export var helpIcon = "_r8-3";
export var helpIconContainer = "_r8-4";
export var verticalDivider = "_r8-2";